import { salesTypeActionSelectors as selector } from "../Selectors/index";

export const salesTypeReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET:
      return payload;

    default:
      return state;
  }
};
